import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddImage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 49,
	height: 48,
	viewBox: "0 0 49 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M38.5 14V19.98C38.5 19.98 34.52 20 34.5 19.98V14H28.5C28.5 14 28.52 10.02 28.5 10H34.5V4H38.5V10H44.5V14H38.5ZM32.5 22V16H26.5V10H10.5C8.3 10 6.5 11.8 6.5 14V38C6.5 40.2 8.3 42 10.5 42H34.5C36.7 42 38.5 40.2 38.5 38V22H32.5ZM10.5 38L16.5 30L20.5 36L26.5 28L34.5 38H10.5Z",
		fill: "#94D1F5"
	})
});
export default SvgAddImage;
